<template>
  <div class="company-profile ">
    <Header></Header>
    <div class="company-info">
      <b-container>
        <b-row>
          <b-col md="4" cols="12">
            <div class="company-brief">
              <div class="company-logo">
                <img
                  :src="
                    companyData.image && companyData.image.url
                      ? companyData.image.url
                      : require('@/assets/img/company/company-demo.jpg')
                  "
                  alt=""
                />
              </div>
              <div class="company-name">{{ companyData.name }}</div>
              <p class="company-description">{{ companyData.description }}</p>
              <hr />
              <b-row>
                <b-col cols="12" class="text-center fw-bold pb-1">
                  الموظفين</b-col
                >
                <b-col cols="4" class="info-value">
                  <div class="info-label">الكل</div>
                  {{ companyData.no_of_employees }}</b-col
                >
                <b-col cols="4" class="info-value">
                  <div class="info-label">معتمد</div>

                  {{ companyData.no_of_certified_employees }}</b-col
                >
                <b-col cols="4" class="info-value">
                  <div class="info-label">غير معتمد</div>
                  {{
                    companyData.no_of_employees -
                    companyData.no_of_certified_employees
                  }}</b-col
                >
              </b-row>
              <hr />

              <b-row class="justify-content-center">
                <b-row class="company-media mb-1">
                  <b-col cols="2">
                    <vue-feather
                      size="14"
                      stroke="#0765F1"
                      type="mail"
                    ></vue-feather>
                  </b-col>
                  <b-col class="text-start">
                    <a :href="'mailto:' + companyData.email">{{
                      companyData.email
                    }}</a>
                  </b-col>
                </b-row>
                <b-row class="company-media mb-1">
                  <b-col cols="2">
                    <vue-feather
                      size="14"
                      stroke="#0765F1"
                      type="map"
                    ></vue-feather>
                  </b-col>

                  <b-col class="text-start">
                    <a href="#">{{ companyData.address }}</a>
                  </b-col>
                </b-row>
                <b-row class="company-media mb-1">
                  <b-col cols="2">
                    <vue-feather
                      size="14"
                      stroke="#0765F1"
                      type="phone"
                    ></vue-feather>
                  </b-col>

                  <b-col class="text-start">
                    <a href="#"> +917 254 852</a>
                  </b-col>
                </b-row>
                <b-row class="company-media mb-1">
                  <b-col cols="2">
                    <vue-feather
                      size="14"
                      stroke="#0765F1"
                      type="globe"
                    ></vue-feather>
                  </b-col>

                  <b-col class="text-start">
                    <a :href="companyData.website">{{ companyData.website }}</a>
                  </b-col>
                </b-row>
              </b-row>
              <hr />
              <b-row class="justify-content-center">
                <b-row class="company-media info-value">
                  <b-col class="text-end"> نشاط المؤسسة </b-col>

                  <b-col class="text-start info-label">
                    {{ companyData.category }}
                  </b-col>
                </b-row>
                <b-row class="company-media info-value">
                  <b-col class="text-end"> رقم السجل التجارى </b-col>
                  <b-col class="text-start info-label">
                    <a href="#"> {{ companyData.commercial_register_num }}</a>
                  </b-col>
                </b-row>
                <b-row class="company-media info-value">
                  <b-col class="text-end"> تاريخ انتهاء السجل </b-col>

                  <b-col
                    class="text-start info-label"
                    :style="{ color: isPastDate ? 'red' : '' }"
                  >
                    <a href="#">{{
                      companyData.commercial_register_expire_at
                    }}</a>
                  </b-col>
                </b-row>
                <b-row class="company-media info-value">
                  <b-col class="text-end"> مكان السجل التجارى </b-col>

                  <b-col class="text-start info-label">
                    <a href="#">{{
                      companyData.commercial_register_address
                    }}</a>
                  </b-col>
                </b-row>
                <b-row class="company-media info-value">
                  <b-col class="text-end"> المدينه </b-col>

                  <b-col class="text-start info-label">
                    <span v-if="companyData.city">{{
                      companyData.city.name
                    }}</span>
                  </b-col>
                </b-row>
              </b-row>
            </div>
          </b-col>
          <b-col md="8" cols="12">
            <div class="tab-container">
              <EmployeesList
                @search="updateSearch"
                :employeesList="employeesList"
                @page-change="handlePageChange"
                :columns="columns"
              ></EmployeesList>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <EditCompanyProfileModal ref="editCompanyProfileModal" />

    <Footer></Footer>
  </div>
</template>
<script>
import EmployeesList from "@/components/Company/EmployeesList.vue";
import Header from "@/components/Company/Header.vue";
import Footer from "@/components/Home/Footer.vue";
import axios from "axios";

export default {
  name: "CompanyShow",
  components: { Header, Footer, EmployeesList },
  data() {
    return {
      tabIndex: 0,
      companyData: {},
      companyLocation: {},
      employeesList: [],
      searchQuery: null,
      columns: [
        { field: "name", title: "الموظف" },
        { field: "position", title: "مسمى الوظيفى" },
        { field: "gender", title: " الجنس" },
        { field: "employee_code", title: " رقم التسلسلى" },
        { field: "certified", title: " معتمد" },

        { field: "actions", title: "عرض" },
      ],
    };
  },
  async created() {
    // Fetch data from APIs
    await this.fetchCompanyData();
    await this.fetchEmployeesList();
  },
  watch: {
    searchQuery: {
      handler: "fetchEmployeesList",
      immediate: true,
    },
  },
  computed: {
      isPastDate() {
        console.log("hh", this.companyData.commercial_register_expire_at);
        // Assuming you have a method to check if the date is in the past
        const currentDate = new Date();
        const expirationDate = new Date(
          this.companyData.commercial_register_expire_at
        );
        console.log(expirationDate < currentDate);

        return expirationDate < currentDate;
      },
    },
  methods: {
    async fetchCompanyData() {
      try {
        const response = await axios.get(
          `ministries/companies/${this.$route.params.id}`
        );
        this.companyData = response.data.data.company;
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    },
    async fetchEmployeesList(page) {
      try {
        const response = await axios.get(
          `ministries/companies/${this.$route.params.id}/employees?`,
          {
            params: { value: this.searchQuery, field: "name", page: page },
          }
        );
        this.employeesList = response.data.data;
      } catch (error) {
        console.error("Error fetching employees list:", error);
      }
    },

    handlePageChange(page) {
      this.fetchEmployeesList(page);
    },
    async updateSearch(query) {
      // Update the search query and make the API call
      this.searchQuery = query;
    },
  },
};
</script>
<style lang="">
</style>
